module.exports = __webpack_public_path__ + "af983ab1f8e86550aa2db4f9bc30091c.svg";